var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256.81 29.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u05E4\\u05E2\\u05D9\\u05DC\\u05D5\\u05EA_\\u05E6\\u05D9\\u05D1\\u05D5\\u05E8\\u05D9\\u05EA",
    "data-name": "\\u05E4\\u05E2\\u05D9\\u05DC\\u05D5\\u05EA \\u05E6\\u05D9\\u05D1\\u05D5\\u05E8\\u05D9\\u05EA"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.81,9.07H0V.94h27.02v28.2h-9.21V9.07ZM.33,14.24h9.21v14.9H.33v-14.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.65,9.07h-12.83V.94h26.18v8.13h-4.14v20.07h-9.21V9.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.55,29.14h-9.21v-14.1c0-8.74,6.49-15.04,15.32-15.04s15.18,6.3,15.18,15.04c0,12.31-9.12,17.25-18.99,13.49l2.26-7.57c3.9,1.5,7.52-.24,7.52-5.92,0-3.85-2.54-6.58-5.97-6.58s-6.11,2.73-6.11,6.58v14.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.01.94v28.2h-27.87v-8.13h4.89V.94h9.21v20.07h4.56V.94h9.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.55,9.07h-7.29v20.07h-14v-8.13h4.79v-11.94h-3.38V.94h29.09v28.2h-9.21V9.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M175.54.94h9.21v28.2h-9.21V.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.57,9.07h-13.02V.94h22.23v28.2h-9.21V9.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M217.33.94h9.21v15.51h-9.21V.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.57.94h9.21v15.51h-9.21V.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M247.6,21.01V.94h9.16l.05,28.2h-16.45v-8.13h7.24Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdpi);
export default __webpack_public_path__ + "static/media/ניירות עמדהmdpi.150621b1a1c26a31fd852a2322b5d2c4.svg";
export { ForwardRef as ReactComponent };